// 重写路由拦截
// 向 permission 添加 handle 属性类型为 function 传入的参数为 router 实例
// example
// const permission = {
//   handle(router) {}
// };

const permission = {};

export default permission;
